// gimme: conversations-thread-view 06/30/2021 cfef6b9a8b3badc65b082ffd722b737fa8d16bdf
import SmallToggleButton from 'hubspot-prosemirror/draft-transplant/components/SmallToggleButton';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { jsx as _jsx } from "react/jsx-runtime";
const AttachButton = props => {
  return /*#__PURE__*/_jsx(SmallToggleButton
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'icon' does not exist on type 'IntrinsicAttributes & IntrinsicClassAttributes<SmallToggleButton> & Readonly<{}>'.
  , Object.assign({
    icon: "attach",
    "data-test-id": "select-file-dropdown"
  }, props));
};
AttachButton.displayName = 'AttachButton';
const SelectFileDropdown = ({
  children,
  onOpenChange,
  open
}) => {
  return /*#__PURE__*/_jsx(Dropdown, {
    open: open,
    onOpenChange: e => onOpenChange(e.target.value),
    closeOnOutsideClick: true,
    buttonText: " ",
    caretRenderer: null,
    Button: AttachButton,
    children: /*#__PURE__*/_jsx(List, {
      children: Array.isArray(children) ? children === null || children === void 0 ? void 0 : children.map(child => /*#__PURE__*/_jsx(ListItem, {
        children: child
      }, child)) : /*#__PURE__*/_jsx(ListItem, {
        children: children
      })
    })
  });
};
SelectFileDropdown.displayName = 'SelectFileDropdown';
export default SelectFileDropdown;